import React from 'react';
import classes from './ScreenerSurvey.module.scss';
import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'react-relay';
import { ScreenerSurveyQuery } from './__generated__/ScreenerSurveyQuery.graphql';
import ErrorPage from '../ErrorPage/ErrorPage';

export interface Props {}

const query = graphql`
  query ScreenerSurveyQuery {
    signupSurveyUrl
  }
`;

const ScreenerSurvey: React.FC<Props> = () => {
  const data = useLazyLoadQuery<ScreenerSurveyQuery>(
    query,
    {},
    {
      fetchPolicy: 'store-and-network',
    },
  );

  if (data.signupSurveyUrl) {
    return <iframe className={classes.iframe} src={data.signupSurveyUrl} title="signup-survey" />;
  }
  return <ErrorPage errorDescription="Did you already sign up to surveys?" />;
};
export default ScreenerSurvey;
